import { Route, Routes } from 'react-router-dom';
import './App.css';
import { Navbar, Footer } from './components';
import { Home, Portfolio, Hobbies, Contact } from './pages';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/hobbies' element={<Hobbies />} />
        <Route path='/contact' element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
